import * as React from 'react'

function IconDownload(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={47}
      height={44}
      viewBox="0 0 47 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M43.795 16.24v12.669c0 6.568-5.33 11.89-11.908 11.89H15.113c-6.578 0-11.908-5.327-11.908-11.89v-12.67M23.5 3.2v22.335"
        stroke="#F4BA27"
        strokeWidth={7}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M14.22 21.148l6.144 7.145a4.14 4.14 0 006.277 0l6.144-7.145"
        stroke="#F4BA27"
        strokeWidth={7}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default IconDownload
